import { render, staticRenderFns } from "./single_config_manager.vue?vue&type=template&id=3b2641ea&"
import script from "./single_config_manager.vue?vue&type=script&lang=js&"
export * from "./single_config_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b2641ea')) {
      api.createRecord('3b2641ea', component.options)
    } else {
      api.reload('3b2641ea', component.options)
    }
    module.hot.accept("./single_config_manager.vue?vue&type=template&id=3b2641ea&", function () {
      api.rerender('3b2641ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/configurations/single_config_manager.vue"
export default component.exports